import { ArticleHeading1, ArticleParagraph1, Button } from '@cian/ui-kit';
import { IconProductHighDemand16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './CianGptBanner.css';

interface ICianGptBannerProps {
  onClick: VoidFunction;
}

export const CianGtpBanner: React.FC<ICianGptBannerProps> = ({ onClick }) => {
  return (
    <div onClick={onClick} className={styles['gpt-banner']}>
      <div className={styles['text']}>
        <ArticleHeading1 color="text-primary-default" whiteSpace="nowrap">
          Удобно искать квартиру с Циан-помощником
        </ArticleHeading1>

        <div className={styles['description']}>
          <ArticleParagraph1 color="text-primary-default">
            Напишите ему, какая квартира нужна, и выбирайте только из подходящих вариантов
          </ArticleParagraph1>
        </div>
      </div>

      <Button beforeIcon={<IconProductHighDemand16 color="icon-main-default" />} theme="fill_white_primary">
        Попробовать
      </Button>
    </div>
  );
};
